<template lang="pug">
div
  el-row
    el-col(:sm="24")
      p.info Tipo de documento:
        span {{tipoDocumento}}

    el-col(:sm="24")
      p.info Protocolo:
        span {{documento.protocolo}}

    el-col(:sm="12")
      p.info Responsável(eis):
        .item-list(v-for="assinador in documento.assinadores")
          span {{assinador.responsavel.usuario.pessoa.nomeRazaoSocial}}

    el-col(:sm="12")
      p.info Data(s) de assinatura:
        .item-list(v-for="assinador in documento.assinadores")
          span {{assinador.dataAssinatura}}

    slot(name="baixar")

</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  mixins: [
    AppNotificacao
  ],
  async created () {
    if (_.isEmpty(this.documento)) { // eslint-disable-line
      await this.consultaDocumento(this.$route.params.protocolo)
    }
  },
  computed: {
    ...mapGetters({
      documento: 'documentosAutenticaveis/item'
    }),
    tipoDocumento () {
      if (this.documento.tipo) {
        return this.documento.tipo.nome
      }
    }
  },

  methods: {
    ...mapActions({
      consultaDocumento: 'documentosAutenticaveis/consultaAutenticidade'
    })
  }
}
</script>
<style lang="scss" scoped>
.info {
  font-weight: bold;
  font-size: 16px;
  margin: 10px 0 5px 0;
}

.title {
  font-size: 25px;
}

span {
  font-weight: normal;
  margin-left: 5px;
}

.item-list {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/DocumentoAssinatura.vue